import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import UnitDetails from './UnitDetails';
import '../../reusableComponents/sideDrawerMenu/sideDrawerMenu.scss'
import { huntPlannerRightMenuBarOpen, huntPlannerRightMenuBarClose } from '../../../../action/huntplanner-menu-bar';
import { fetchGetUnitDetails } from '../../../../action/huntPlanner-unitdetails-actions';
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options';
import Loader from '../../reusableComponents/loader/Loader';
import { multiTileHuntLayers } from '../../huntplanner-layer-render/renderlayerFunction';
import { removeLayers } from '../../huntplanner-layer-render/renderlayerFunction';
import { getAPi } from '../../api/api';
import { fetchGetFilterValues } from '../../../../action//huntPlanner-api-actions';
import { stopMapLoading } from '../../../../action/huntplanner-map-loader';

const RightMenubar = (props) => {
  const [unitDetails, setUnitDetails] = useState()
  const [loader, setLoader] = useState(true)
  useEffect(() => {
    if (props.huntPlannerUnitRightMenuBar.expanded) {
      let reslen = props.huntPlannerUnitRightMenuBar?.mapData?.[0]?.features.length
      let payload = {
        ...props.huntPlannerSelectedOtions,
        unitName: props.huntPlannerUnitRightMenuBar?.mapData?.[0]?.features?.[reslen - 1]?.properties?.Unit || ''
      }
      let layerId = props.huntPlannerUnitRightMenuBar?.mapData?.[0]?.layer?.LayerId
      let layerPayload = {
        unitName: (props.huntPlannerUnitRightMenuBar?.mapData?.[0]?.features?.[reslen - 1]?.properties?.Unit || '').trim(),
      }
      let layerRenderingApi = `layer/RenderSingleHuntUnit/${layerId}`
      const params = new URLSearchParams(layerPayload).toString();
      if (layerPayload.unitName) {
        fetchFilterMenuValue(payload)
          .then((response) => {
            if (props.huntPlannerUnitRightMenuBar?.unitDetails) {
              multiTileHuntLayers('object',
                layerPayload,
                { mapInstance: props.huntplannerMapReference, filters: [] },
                true,
                layerRenderingApi,
                params,
                response,
                () => {
                })
              setUnitDetails(props.huntPlannerUnitRightMenuBar?.unitDetails)
            } else {
              props.fetchGetUnitDetails(payload)
                ?.then((res) => {
                  if (res != 'Requested unit is not currently visible') {
                    // removeLayers(props.huntplannerMapReference)
                    // props.huntplannerMapReference.setCenter(props.huntPlannerUnitRightMenuBar?.coordinates);
                    // props.huntplannerMapReference.setZoom(9);
                    multiTileHuntLayers('object',
                      layerPayload,
                      { mapInstance: props.huntplannerMapReference, filters: [] },
                      true,
                      layerRenderingApi,
                      params,
                      response,
                      () => {
                      })
                    setUnitDetails(res)
                  }
                  else {
                    props.stopMapLoading()
                    setLoader(false)
                  }

                })
                .catch((err) => {
                  console.log(err)
                })
            }
          })
          .catch(err => {
            setLoader(false)
          })
      }
      else {
        console.log('layer dont have unit data')
      }
      props.huntPlannerActiveOtions(payload)
    }
  }, [props.huntPlannerUnitRightMenuBar])

  let close = () => {
    let payload = {
      ...props.huntPlannerSelectedOtions,
    }

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
        delete payload[key];
      }
    });

    const params = new URLSearchParams(payload).toString();

    let layerRenderingApi = 'Layer/RenderHuntUnits'
    // const params = new URLSearchParams(payload).toString();
    // fetchFilterMenuValue(payload)
    //   .then((response) => {
    // removeLayers(props.huntplannerMapReference)
    multiTileHuntLayers('object',
      payload, { mapInstance: props.huntplannerMapReference, filters: [] }, true, layerRenderingApi, params, props.huntPlannerFilterOptions, () => {
      })
    // })

    props.huntPlannerRightMenuBarClose()
  }

  let fetchUnitDetails = (payload) => {
    if (payload.unitName) {
      // debouncedFetchUnitDetails(payload)
      props.fetchGetUnitDetails(payload)
        ?.then((res) => {
          if (res != 'Requested unit is not currently visible')
            setUnitDetails(res)
          else
            setLoader(false)
        })
        .catch((err) => {
          // setLoader(false)
          console.log(err);
        })
    }
  }

  // Debounce utility
  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  // Debounced function to fetch unit details
  const debouncedFetchUnitDetails = useCallback(
    debounce((payload) => {
      props.fetchGetUnitDetails(payload)
        ?.then((res) => {
          if (res != 'Requested unit is not currently visible')
            setUnitDetails(res)
          else
            setLoader(false)
        })
        .catch((err) => {
          // setLoader(false)
          console.log(err);
        })
    }, 5000),
    []
  );


  let fetchFilterMenuValue = (payloadData) => {
    return new Promise((resolve, reject) => {
      let payload = {
        StateAbbreviation: payloadData.StateAbbreviation,
        Species: payloadData.Species,
        HuntTypeKey: payloadData.HuntTypeKey,
      };
      let api = 'HuntPlanner/GetFilterValues';
      const params = new URLSearchParams(payload).toString();
      let apiUrlPayload = `${api}?${params}`;
      // getAPi('version', '', props.auth.token, payload, apiUrlPayload)
      props.fetchGetFilterValues(payload)
        .then((res) => {
          resolve(res); // Resolve the promise with response data
        })
        .catch((error) => {
          console.error('API Error:', error);
          reject(error); // Reject the promise with error
        });
    });
  };

  return (
    <>
      {props.huntPlannerUnitRightMenuBar.expanded && props.huntPlannerUnitRightMenuBar?.mapData ?
        <div className='side-Drawer-model-container' style={{
          height: '87vh',
          width: `${23.4375 + 23.4375}vw`,
          justifyContent: loader ? 'space-between' : ''
        }}>
          {unitDetails && unitDetails != 'Requested unit is not currently visible' ?
            <UnitDetails
              closeTheCard={() => { close() }}
              unitData={unitDetails}
              selectedFilterOptions={props.huntPlannerSelectedOtions}
              unitDetailsResponse={unitDetails}
              from={"map"}
            />

            :
            <>
              {/* <div className="unit-map-details-container">
                <div className="back-arrow-div-map">
                  <img onClick={() => { close() }} src={require('../../../../../asset/Close-X_Thin_F2F2F2_SVG.svg')} className="back-arrow-map-style" style={{ height: 20 }}></img>
                </div>
              </div> */}
              <div className="unit-details-container" style={{ maxHeight: 160 }}>
                <div className="back-arrow-div">
                  <img onClick={() => { close() }} src={require('../../../../../asset/Close-X_Thin_F2F2F2_SVG.svg')} className="back-arrow-style" style={{ height: 20 }}></img>
                </div>
              </div>

              {loader ?
                <Loader
                  position={'absolute'} left={'42%'} width={'30px'}
                ></Loader>
                :
                <div className="unit-card-item" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <p>Requested unit is not currently visible</p>
                </div>
              }
            </>
          }
        </div>
        :
        null
      }
    </>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions
})

const mapDispatchToProps = dispatch => ({
  // huntPlannerRightMenuBarOpen: (payload) => dispatch(huntPlannerRightMenuBarOpen(payload)),
  huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
  fetchGetUnitDetails: (payload) => dispatch(fetchGetUnitDetails(payload)),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  fetchGetFilterValues: (payload) => dispatch(fetchGetFilterValues(payload)),
  stopMapLoading: () => dispatch(stopMapLoading()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RightMenubar)
